interface DirectionsAmenitiesProps {
  companyName: string;
  amenities: Record<string, boolean | number>;
  /**
   * 값이 false 일 때 쓸 문구. 장례식장은 "이용 불가"가 맞지만 장지에서는
   * 식당이 없는 게 이용 제한이 아니라 그냥 없는 것이라 "없음"을 쓴다.
   */
  unavailableLabel?: string;
  /** 섹션 이동 nav 에서 앵커로 쓸 id */
  sectionId?: string;
}

const AMENITY_ITEMS: Array<{ key: string; label: string }> = [
  { key: "has_mealroom", label: "식당" },
  { key: "has_waitroom", label: "유족 대기실" },
  { key: "has_super", label: "매점" },
  { key: "has_parkinglot", label: "주차장" },
  { key: "has_facilities_for_impaired", label: "장애인 편의시설" },
];

export const DirectionsAmenities = ({
  companyName,
  amenities,
  unavailableLabel = "이용 불가",
  sectionId,
}: DirectionsAmenitiesProps) => {
  return (
    <section
      className="dr-section"
      id={sectionId}
      aria-labelledby="dr-amenities-title"
    >
      <h2 id="dr-amenities-title" className="dr-section__title">
        {`${companyName} 편의시설`}
      </h2>
      <p className="dr-section__lede">이용 가능한 편의시설 안내입니다.</p>
      <table className="dr-info-table" aria-label={`${companyName} 편의시설`}>
        <tbody>
          {AMENITY_ITEMS.map((item) => {
            const value = amenities[item.key];
            const status =
              value === true
                ? "이용 가능"
                : value === false
                ? unavailableLabel
                : "정보 없음";
            return (
              <tr key={item.key}>
                <th scope="row">{item.label}</th>
                <td>{status}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </section>
  );
};
